import HTTPHandler, { formatResponse } from 'lib/api/HTTPHandler'
import { NOTIFICATION_API_URL } from 'lib/api/env'
import { createError } from 'lib/api/serverError'
import { typesNames } from 'constants/events'
import { format } from 'date-fns'

export class TaskService {
  static getMyEvents = async (data = {}, limit = 10, offset = 0) => {
    try {
      const res = await HTTPHandler.post(
        NOTIFICATION_API_URL + '/events/getMyEvents',
        {
          ...data,
          limit,
          offset
        }
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }
  static getEvents = async (data = {}, limit = 100, offset = 0) => {
    try {
      const res = await HTTPHandler.post(
        NOTIFICATION_API_URL + '/events/events',
        {
          ...data,
          limit,
          offset
        }
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static addEvent = async (data = {}) => {
    try {
      const response = await HTTPHandler.post(
        NOTIFICATION_API_URL + '/events/v2/addEvent',
        {
          assignTo: data?.assignTo,
          title: typesNames[data.type],
          group: 'call',
          start: format(new Date(), 'yyyy-MM-dd HH:mm'),
          end: format(data.date, 'yyyy-MM-dd HH:mm'),
          type: data.type,
          description: data.description,
          contactFullname: data?.contactFullname,
          contactPhone1: data?.phoneNumber,
          contactPhone2: data?.additionalPhoneNumber,
          dealId: data?.dealId,
          assignToFullname: data?.assignToFullName,
          globalId: data.globalId,
          branchCode: data?.branchCode || undefined
        }
      )

      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }

  static addEventCsIssue = async (data = {}) => {
    try {
      const res = await HTTPHandler.post(
        NOTIFICATION_API_URL + '/events/addEventCsIssue',
        data
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static updateEvent = async (data = {}) => {
    try {
      const res = await HTTPHandler.post(
        NOTIFICATION_API_URL + '/events/updateEvent',
        data
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static completeEvent = async (data = {}) => {
    try {
      const res = await HTTPHandler.post(
        NOTIFICATION_API_URL + '/events/completeEvent',
        data
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }
}
